exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".pageForbidden_from_PageForbidden-css_9lm {\r\n  position: fixed;\r\n  overflow: auto;\r\n  top: 0;\r\n  left: 0;\r\n  width: 100%;\r\n  height: 100%;\r\n  display: -webkit-box;\r\n  display: -ms-flexbox;\r\n  display: flex;\r\n  -webkit-box-pack: center;\r\n      -ms-flex-pack: center;\r\n          justify-content: center;\r\n  -ms-flex-line-pack: center;\r\n      align-content: center;\r\n  -webkit-box-align: center;\r\n      -ms-flex-align: center;\r\n          align-items: center;\r\n}\r\n", ""]);

// exports
exports.locals = {
	"pageForbidden": "pageForbidden_from_PageForbidden-css_9lm"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--3-1!./node_modules/postcss-loader/lib??ref--3-2!./app/web/src/routes/errors/PageForbidden/PageForbidden.css
// module id = ./node_modules/css-loader/index.js??ref--3-1!./node_modules/postcss-loader/lib/index.js??ref--3-2!./app/web/src/routes/errors/PageForbidden/PageForbidden.css
// module chunks = 0